import {Power0} from 'gsap';

const animatinGears = (node) => {
	gsap.to(node.querySelectorAll('.gears'), {
		duration: 5,
		ease: Power0.easeNone,
		repeat: -1,
		transformOrigin: 'center',
		rotate: 360,
	});
};

export {animatinGears};
